import { render, staticRenderFns } from "./PageHeaderWithBreadcrumbs.vue?vue&type=template&id=29a95fae&"
import script from "./PageHeaderWithBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./PageHeaderWithBreadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports